import { useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { useAppSelector } from '../../hooks/reduxToolkit';
import { NotFound } from '../../screens/notFound';
import { ProviderConversationsPanel } from '../../components/providers/ProviderConversationsPanel';
import { selectConversationsWithNestedDataForProvider } from '../../reduxToolkit/conversationsSelectors';
import { present } from '../../../lib/util/present';

export function ProviderConversations() {
  const { id } = useParams<{ id: string }>();
  const provider = useAppSelector((state) => state.providers?.providers.find((p) => p.id === id));
  const conversations = useAppSelector((state) =>
    selectConversationsWithNestedDataForProvider(state, provider?.id || '')
  );

  const [showClosed, setShowClosed] = useState(false);

  const closedCount = useMemo(
    () =>
      conversations.filter(
        (c) =>
          c.status === 'CLOSED' &&
          (c.messages.length > 0 || c.phone_calls.length > 0)
      ).length,
    [conversations]
  );

  if (!provider || !id) {
    return <NotFound />;
  }

  return (
    <div className="provider-conversations">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Conversations with {provider.name}</h1>
        {closedCount > 0 && (
          <button
            type="button"
            className="btn btn-link btn-sm"
            onClick={() => setShowClosed(!showClosed)}
          >
            {showClosed ? 'Show open' : `Show closed (${closedCount})`}
          </button>
        )}
      </div>

      <ProviderConversationsPanel
        providerId={id}
        conversations={conversations}
        isAuthorized={present(provider.communication_authorized_at)}
        showClosed={showClosed}
      />
    </div>
  );
}
